import React, { useState } from "react";
import Contact from "../contact";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/SC190.jpg";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import { Helmet } from "react-helmet-async";

const PermanentResidenceRegional191 = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div>
      <Helmet>
        <title>Subclass 191 Visa: Permanent Residence Regional – Immiget Global Australia</title>
        <meta
          name="description"
          content="Get your Subclass 191 Permanent Residence Regional visa with Immiget Global. Expert guidance for skilled workers transitioning from provisional to permanent residency."
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Permanent Residence Regional (Subclass 191)
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Individual & Families
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Permanent Residence Regional (Subclass 191)
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="xl:flex gap-4 justify-center container max-w-1440px mx-auto px-4 py-4 md:py-10 lg:px-14">
        <div className="xl:w-[50%]">
          <h1 className="xl:text-[30px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
            What is the Subclass 191 Visa?
          </h1>
          <p className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
            The Permanent Residence (Skilled Regional) Visa (Subclass 191) is for skilled workers who have held a Subclass 491 or 494 visa for at least 3 years, lived and worked in regional Australia, and met all visa conditions. This visa grants permanent residency status with full freedom to live, work, and study anywhere in Australia.
          </p>
        </div>
        <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
          <img src={visaImage} alt="Subclass 191 visa" />
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Eligibility Requirements */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Eligibility Requirements for Subclass 191 Visa
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          To qualify for the Subclass 191 visa, you must:
        </div>
        <div className="lg:ml-4 mt-4">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              <strong>Hold an Eligible Provisional Visa:</strong> Subclass 491 (Skilled Work Regional Visa) or Subclass 494 (Skilled Employer-Sponsored Regional Visa)
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              <strong>Meet the Regional Residence Requirement:</strong> Lived in a designated regional area for at least 3 years
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              <strong>Income Requirement:</strong> Worked in a regional area with minimum AUD $53,900 taxable income per year for 3 years
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              <strong>Comply with Visa Conditions:</strong> No breaches of previous visa conditions
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg xl:text-[20px] font-normal hellix-font">
              Meet health & character requirements and have no outstanding debts to the Australian Government
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Benefits Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Benefits of the Subclass 191 Visa
          </h1>
        </div>
        <p className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          The Subclass 191 visa provides permanent residency with comprehensive benefits and opportunities for you and your family.
        </p>
        <div className="flex flex-wrap justify-between mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={permanentIcon} alt="permanent-icon" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font">
              Permanent residency with full work and study rights
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={unlimitedIcon} alt="unlimited-icon" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font">
              No restrictions on location (can move anywhere in Australia)
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={iconPeople} alt="citizenship-icon" />
            </div>
            <div className="text-blue text-lg font-normal text-center hellix-font">
              Pathway to Australian citizenship (after 4 years as PR)
            </div>
          </div>
        </div>
        <div className="flex gap-8 justify-center flex-wrap mt-8">
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={materialIcon} alt="family-icon" />
            </div>
            <div className="text-blue text-lg font-normal max-md:px-2 text-center hellix-font">
              Sponsor eligible family members for permanent residence
            </div>
          </div>
          <div className="shadow-custom-white mt-4 flex flex-col gap-4 rounded-[16px] justify-center items-center w-[410px] h-[206px]">
            <div>
              <img src={medicareIcon} alt="medicare-icon" />
            </div>
            <div className="text-blue text-lg text-center max-md:px-2 font-normal hellix-font">
              Access to Medicare and social security benefits
            </div>
          </div>
        </div>
      </div>

      {/* Application Process */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            How to Apply for the Subclass 191 Visa
          </h1>
        </div>
        <div className="lg:ml-8 hellix-font mt-3">
          <div className="flex gap-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 1:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              Hold a Subclass 491 or 494 Visa for at least 3 years
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[22px] font-semibold text-blue">
              Step 2:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              Meet Income & Residence Requirements (3 years in regional Australia)
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 3:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              Gather Documents (proof of income, employment, residency, etc.)
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 4:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              Lodge Your Application Online via the Department of Home Affairs
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 5:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              Wait for Approval (processing times vary)
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <div className="hellix-font text-lg lg:text-[20px] font-semibold text-blue">
              Step 6:
            </div>
            <div className="hellix-font text-lg lg:text-[20px] font-normal text-blue">
              Receive PR Status and enjoy life in Australia!
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Choose Immiget Global */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            Why Choose Immiget Global?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Start Your Australian PR Journey Today! We provide expert guidance for your Subclass 191 visa application:
        </div>
        <div className="lg:ml-4 mt-4">
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Expert Guidance</strong> – We simplify complex PR pathways
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>High Success Rate</strong> – Proven track record with skilled visas
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>End-to-End Support</strong> – From provisional visa to permanent residency
            </div>
          </div>
          <div className="flex gap-2">
            <div>
              <img src={rightVector} alt="" className="min-w-[30px]" />
            </div>
            <div className="text-blue text-lg lg:text-[20px] font-normal hellix-font">
              <strong>Post-Visa Assistance</strong> – Help with citizenship applications
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How Immiget Will Help You */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={helpIcon} alt="help" />
          </div>
          <h1 className="lg:text-[28px] text-2xl text-blue font-semibold hellix-font">
            How Immiget Will Help You?
          </h1>
        </div>
        <div className="text-blue font-normal text-lg lg:text-[20px] mt-2 hellix-font">
          Immiget Global is here to assist at every stage of your Subclass 191 visa journey. Our team provides:
        </div>
        <div className="xl:flex gap-6 mt-4">
          <div className="xl:w-[50%]">
            <img src={helpImage} alt="help" className="h-[100%]" />
          </div>
          <div className="xl:w-[50%] max-xl:mt-4 flex flex-col gap-1">
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Comprehensive Eligibility Assessment:
                  <span className="font-normal">
                    We review your provisional visa history and ensure you meet all requirements before application.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Documentation Preparation:
                  <span className="font-normal">
                    We help gather and prepare all required documents including income evidence and residency proof.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Application Management:
                  <span className="font-normal">
                    We handle the complete application process and liaise with the Department of Home Affairs.
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-inside">
                <li className="text-blue text-xl lg:text-[20px] hellix-font font-semibold">
                  Ongoing Support:
                  <span className="font-normal">
                    We provide updates throughout the process and assist with any requests from immigration authorities.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <h1 className="lg:text-[28px] text-2xl text-center text-blue font-semibold hellix-font">
          Subclass 191 Visa FAQs
        </h1>
        <p className="text-blue font-normal text-xl lg:text-[20px] text-center hellix-font">
          Get answers to common questions about the Permanent Residence (Skilled Regional) Visa (Subclass 191).
        </p>

        <div className="accordion-container mt-8">
          {/* FAQ 1 */}
          <div className="accordion">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(1)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Can I include my family in the Subclass 191 application?
              </h2>
              {activeIndex === 1 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 1 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes, your spouse and dependent children can be included in your Subclass 191 visa application.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 2 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(2)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                What if I don't meet the income requirement?
              </h2>
              {activeIndex === 2 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 2 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  You must meet the minimum taxable income (AUD $53,900/year for 3 years) to qualify for the Subclass 191 visa.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 3 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(3)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                How long does processing take?
              </h2>
              {activeIndex === 3 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 3 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Processing times vary, but typically take several months after submission. The exact timeframe depends on the completeness of your application.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 4 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(4)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                Can I move to a major city after getting PR?
              </h2>
              {activeIndex === 4 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 4 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  Yes! Unlike the 491/494 visas, the Subclass 191 has no regional restrictions. You can live and work anywhere in Australia.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 5 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(5)}
            >
              <h2 className="md:text-lg text-lg text-blue font-medium hellix-font">
                What documents do I need for the Subclass 191 application?
              </h2>
              {activeIndex === 5 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 5 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-lg text-lg font-normal hellix-font">
                  You'll need proof of income, employment records, residency evidence, health and character certificates, and documentation showing compliance with your previous visa conditions.
                </p>
              </div>
            )}
          </div>

          {/* FAQ 6 */}
          <div className="accordion mt-2">
            <div
              className="accordion-header flex justify-between items-center p-4 cursor-pointer border-b"
              onClick={() => toggleAccordion(6)}
            >
              <h2 className="md:text-xl text-lg text-blue font-medium hellix-font">
                How can Immiget Global help with my Subclass 191 application?
              </h2>
              {activeIndex === 6 ? <FaTimes /> : <FaPlus />}
            </div>
            {activeIndex === 6 && (
              <div className="accordion-content p-4">
                <p className="text-[#667d87] md:text-xl text-lg font-normal hellix-font">
                  We provide comprehensive support including eligibility assessment, document preparation, application lodgment, and ongoing communication with immigration authorities throughout the process.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default PermanentResidenceRegional191;